import React, { useState } from 'react'
import { Button } from 'components/Button';
import { FormBoxHeading, FormBoxWrapper, FormRightBox, FormSubmitBtn, InputFieldStyle } from '../FormsStyled';
import { FormErrorColor } from '../ModalStyled';
import { useForm, SubmitHandler } from 'react-hook-form';
import FormImage from '../FormImageBox';
import { Link, useHistory, useLocation } from "react-router-dom"
import { Box } from 'components/Box';
import { ReactComponent as BackIcon } from 'assets/Icons/BackIcon.svg';
import axios from 'libs/axios';
import { toast } from 'react-toastify';

type Inputs = {
    email: string,
    password: string,
    ConfirmPassword: string,
    code: string,
};

const ForgotPassword: React.FC = () => {

    const [open, setOpen] = useState(false);
    const { register, handleSubmit, getValues, formState: { errors } } = useForm<Inputs>();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const { search } = useLocation();
    const urlValues = React.useMemo(() => new URLSearchParams(search), [search]);
    const email = urlValues.get('email');
    const code = urlValues.get('code');

    const onSubmit: SubmitHandler<Inputs> = async data => {
        try {
            setLoading(true);
            const result = await axios.post('/user/reset-password', data);
            toast.success(result.data.message);
            history.push("/passwordconfirmation");
        } catch (err) {
            //@ts-ignore
            toast.error(err.response.data.message);
        } finally {
            setLoading(false);
        }
    }
    return (

        <FormBoxWrapper>

            <FormImage />

            <Box>
                <Box display={['none', 'none', 'none', 'block']}>
                    <Link to="/">
                        <BackIcon />
                    </Link>
                </Box>
                {/* handleSubmit(onSubmit)(e); e.stopPropagation() */}
                <FormRightBox>
                    <FormBoxHeading>RESET PASSWORD</FormBoxHeading>

                    <form onSubmit={handleSubmit(onSubmit)}>

                        <InputFieldStyle style={{ visibility: 'hidden', position: 'absolute' }}>
                            <label>6 Digits Code ( Code Expire in 1 minute )</label>
                            <input type="number" className="form-control" {...register("code")} readOnly value={code} />
                            <FormErrorColor>{errors.code && errors.code.message}</FormErrorColor>
                        </InputFieldStyle>

                        <InputFieldStyle style={{ visibility: 'hidden', position: 'absolute' }}>
                            <label>Email</label>
                            <input type="email" className="form-control" {...register("email")} readOnly value={email} />
                            <FormErrorColor>{errors.email && errors.email.message}</FormErrorColor>
                        </InputFieldStyle>

                        <InputFieldStyle>
                            <label>New Password</label>
                            <input type="password" className="form-control" {...register("password", { required: { value: true, message: "New Password is Required" }, minLength: { value: 6, message: "New Password must be greater than 6 Characters." }, })} />
                            <FormErrorColor>{errors.password && errors.password.message}</FormErrorColor>
                        </InputFieldStyle>

                        <InputFieldStyle>
                            <label>Confirm Password</label>
                            <input type="password" className="form-control" {...register("ConfirmPassword", {
                                required: { value: true, message: "Confirm Password is Required" }, minLength: { value: 6, message: "Confirm Password must be greater than 6 Characters." }, validate: {
                                    checkEq: val => val === getValues('password') || "Confirm Password should be Same."
                                },
                            })} />
                            <FormErrorColor>{errors.ConfirmPassword && errors.ConfirmPassword.message}</FormErrorColor>
                        </InputFieldStyle>

                        <FormSubmitBtn>
                            <Button type="submit">Reset Password</Button>
                        </FormSubmitBtn>

                    </form>

                </FormRightBox>

            </Box>

        </FormBoxWrapper >

    )
}

export default ForgotPassword;